import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import TableQualityGraph from "../QualityTab/TableQualityGraph";
import TableQualityTable from "../QualityTab/TableQualityTable";
import QualityDimesionGraph from "./QualityDimesionGraph";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../../../msalConfig";
import { TELEMETRY_API } from "../../../../../../constants/serverConfig";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { useParams } from "react-router-dom";
const QualityTab = (props) => {
  const [fetching, setISFetching] = useState(false);
  const [data, setData] = useState([]);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };
  const params = useParams();
  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
      title: alert.title,

      icon: alert.icon,

      footer: alert.footer,

      confirmButtonColor: "#0ca0ce",

      allowOutsideClick: false,
    });
  };

  useEffect(() => {
    if (props.qualityTabStatus) {
      const fetchdatasets = async () => {
        try {
          const token = (await instance.acquireTokenSilent(request))
            .accessToken;
          getqualityDimension(token);
        } catch (error) {
          setISFetching(false);
          if (error) {
            try {
              const token = (await instance.acquireTokenRedirect(request))
                .accessToken;
              getqualityDimension(token);
            } catch (error) {
              sweetAlertHandler({
                title: "Error while fetching the data. ",
                icon: "info",
              });
            }
          }
        }
      };
      fetchdatasets();
    }
  }, [instance, props.qualityTabStatus]);

  const getqualityDimension = () => {
    setISFetching(true);
    const QUAL_DIMENSION_URL = `${TELEMETRY_API}metrics/quality/dimensions?dataset_name=${params.id}`;

    axios.get(QUAL_DIMENSION_URL).then((res) => {
      if (res.data.metrics && res.data.metrics.length > 0) {
        setData(res.data.metrics);
      }

      setISFetching(false);
    });
  };
  return (
    <Card className="tabs__card">
      {props.tablequalitytable.length > 0 ? (
        <>
          <Row className="mt-2 ml-5">
            <Col sm={12} md={6} lg={6} xl={6} xxl={6}>
              <TableQualityGraph
                tablequalitygraph={props.tablequalitygraph}
                fetching={props.fetching}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xl={6} xxl={6}>
              <TableQualityTable
                tablequalitytable={props.tablequalitytable}
                fetching={props.fetching}
              />
            </Col>
          </Row>
          <Row className="mt-5">
            {data &&
              data.map((item, index) => {
                return (
                  <Col sm={6} md={6} lg={6} xl={4} xxl={4}>
                    <QualityDimesionGraph
                      qualityTabStatus={props.qualityTabStatus}
                      loading={fetching}
                      name={item.metricKey}
                      value={item.metricValue}
                    />
                  </Col>
                );
              })}
          </Row>
        </>
      ) : (
        <Row>
          <div className="text-center p-5"><span>No data found.</span></div>
        </Row>
      )}

    </Card>
  );
};

export default QualityTab;
